import React, { useState } from 'react';
import PlusIcon from '../Icons/Action/PlusIcon';

export interface CollapseProps {
  header: React.ReactNode;
  children: React.ReactNode;
  isOpenDefault?: boolean;
}

const Collapse: React.FC<CollapseProps> = ({ header, children, isOpenDefault = false }) => {
  const [isOpen, setIsOpen] = useState(isOpenDefault);

  return (
    <div className="bg-gray py-4 px-6 rounded-lg w-full">
      <div className="flex justify-between items-center">
        <div onClick={() => setIsOpen(!isOpen)} className="cursor-pointer flex-1">
          {header}
        </div>
        <button onClick={() => setIsOpen(!isOpen)}>
          <PlusIcon
            className={`transform transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`}
          />
        </button>
      </div>
      <div
        className={`text-base transition-all duration-500 ease-in-out overflow-hidden ${
          isOpen ? 'max-h-screen' : 'max-h-0'
        }`}
      >
        <div
          className={`mt-4 transition-opacity duration-500 ease-in-out ${isOpen ? 'opacity-70' : 'opacity-0'}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Collapse;
